const { Component, render, findDOMNode, Fragment } = wp.element;

const $ = jQuery;
const {
  RangeControl,
  CheckboxControl
} = wp.components;

import ReactPaginate from 'react-paginate';
//import md5 from 'js-md5';

import { AZON_Country_Dropdown } from './country-dropdown.class.js';
import {
  WooZoneNoAWSCategs as AzonCategs,
  WooZoneNoAWS_Country_List as Country_List,
  WooZoneNoAWS_isset as isset,
  WooZoneParser,
  WooZoneMakeID as makeid,
  WooZoneChunk as chunk,
  WooZoneHumanFileSize as humanFileSize,
  WooZoneGetDomain as getDomain,
  WooZoneContentTrimmer as contentTrimmer,
  WooZoneImportUrlGetDebugStep as urlGetDebugStep,
} from "./amz.utils.js";

const alias = 'WooZone-NAWS-'
const image_block_wrapper = document.getElementById( `${alias}wrapper` );

class WooZoneNoAWSImport extends Component {

  constructor(props) {
    super(props);

    this.DEBUG = false;

    this.state = {
      ipc_is_valid: false,
      show_log: true,
      country: 'com',
      categ: 'aps',
      keyword: '',
      search_sort: 'relevanceblender',
      search_result_page: null,
      show_main_loader: false,
      pagination: {},
      products: {},
      paged: 1,
      import_in_progress: false,
      products_get_in_progress: [],
      selected_products: {},
      imported_products: {},
      import_setup: {
        variations: 20,
        images: 20,
        attributes: true,
        spin: false,
        threads: 2,
        type: 'simple'
      },
      logs: {},
      view_log_asin: false,
      fakeUpdateState: 0,
      is_chrome: navigator.userAgent.toLowerCase().indexOf('chrome') > -1,
      extention_loaded: false,
      ipc_valid: false,
      workers: {},
      quick_menu: 'close',
      isfrom: '', // to identify if the click come from pagination links or just hit the search button
    }

    this.nbProducts = 0;

    this.searchFormRef = React.createRef();
    this.searchFieldPaged = React.createRef();

    // debug
    // if( 0 ) {
    //   setTimeout( () => {
    //     document.getElementById("WooZone-NAWS-search-form").elements[4].click();

    //     if( 0 ){
    //       setTimeout( () => {
    //         let products = document.getElementsByClassName("WooZone-NAWS-get-product")
    //         Array.from(products).slice(10, 10).forEach( (elm, index) => {
    //           elm.click();
    //         })

    //         setTimeout( () => {
    //           document.getElementById("WooZone-NAWS-import-form").elements[9].click();
    //         }, 300 )

    //       }, 500 )
    //     }
    //   }, 500 )
    // }
  }

  custom_hash_translate( str )
  {
    if( typeof(str) == "undefined" ) return false;

    return window.atob(str).replace('#-1#', "a").replace('#-5#',"b").replace('#-6#', "c").replace('#-4#', "h").replace('#-21#', "t").replace('#-76#', "w");
  }

  componentDidMount()
  {
    const self = this;
    //console.log( 'urlGetDebugStep', urlGetDebugStep() );
    window.addEventListener("message", function(event) {

      if( event.data.type && (event.data.type == `${alias}response`) ) {

        const { action, sub_action, response, url } = event.data;

        console.log(action, sub_action, response, url );

        if( action == 'extension-loaded' ){

          if( isset(response, 'version') ){
            if( parseFloat(response.version) >= 2 ){
              const de_hash = self.custom_hash_translate( response.hash );

              console.log( de_hash );

              self.setState({ extention_loaded: true, ipc_is_valid: de_hash == WooZoneNoAwsKeysImport.validation.home_url ? true : false });
            }
          }
        }

        if( action == 'url-get-content-response' ){
          if( sub_action == 'search' ){
            self.setState( prevState => {
              const newState = {
                show_main_loader: false,
                search_result_page: response.result,
                pagination: {
                  ...prevState.pagination,
                   // $.trim( $(response.result).find(".s-breadcrumb").text() )
                  ...WooZoneParser( 'paged', response.result, { lang: self.state.country, prevState } ),
                }
              };
              return newState;
            });
          }
          else if( sub_action == 'variations' ){
            if( isset(response, 'call_id') ){
              if( self.state.products_get_in_progress.includes(response.call_id) ){
                self.setProductsVariations( response.call_id, response.result );
              }
            }
          }
          else if( sub_action == 'validation' ){
            if( isset(response, 'call_id') ){
                if( response.result.status == 'invalid' ){
                  alert("Unable to validate your request. Please contact AA-Team support!");
                }

                self.setState({ show_main_loader: false });
                if( response.result.status == 'valid' ){

                  //self.setState({ ipc_is_valid: true });

                  // refresh the page here!
                  window.location.reload();
                  return true;
                }
            }
          }
          else if( sub_action == 'product_page' ){

            // to do
            if( isset(response, 'call_id') ){
              if( self.state.products_get_in_progress.includes(response.call_id) ){

                // trim unwanted page content, make the request smaller and faster
                response.result = contentTrimmer( response.result );

                self.getProductMininalData( response.call_id, response.result, url );
              }
            }
          }
          else{
            if( self.DEBUG ) console.log( `Invalid sub_action: ${sub_action}` );
          }
        }
      }
    })

    this.importWorker();
  }

  setProductsVariations( asin, DOM )
  {
    const variationsJSON = JSON.parse( $.trim( DOM ) );
    if( variationsJSON ){

      this.add_to_log( asin, `Variations prices found: ${variationsJSON.length} items`, 'success' )

      let products = { ...this.state.products }

      if( isset(products, asin) ){
        products[asin].variations = variationsJSON;
        this.setState({ products });

        this.sendToWZoneImport();
      }else{
        if( this.DEBUG ) console.log( `For no reason unable to find your asin into state products!` );
      }
    }else{
      this.add_to_log( asin, `Unable to find any price for your variations`, 'error' )
    }

    this.fakeUpdateState();
  }

  fakeUpdateState()
  {
    this.setState({ fakeUpdateState: Math.floor(Math.random() * 999) + 1 })
  }

  sendToWZoneImport()
  {
    const { selected_products, products, imported_products } = this.state;
    const self = this;

    if( self.DEBUG ) console.log( `it's time to send to WZone and import the products:` );

    if( Object.keys(products).length > 0 ){

      if( selected_products[Object.keys(products)[0]] ){

        const asin = Object.keys(products)[0];

        // debug, to give error. This will not allow the script to import product
        if( 0 ){
          products[asin].DOM = products[asin].DOM.replace('productTitle', 'nop')
          products[asin].DOM = products[asin].DOM.replace('ebooksProductTitle', 'nop')
          products[asin].DOM = products[asin].DOM.replace('mas-title', 'nop')
        }

        let ourdata = {
          asin : asin,
          country : products[asin].domain.replace("amazon.", ""),
          idcateg: document.getElementById("WooZone-to-category").value == '-1' ? 0 : document.getElementById("WooZone-to-category").value,
          nbimages: this.state.import_setup.images,
          nbvariations: this.state.import_setup.variations,
          spin: this.state.import_setup.spin ? 1 : 0,
          attributes: this.state.import_setup.attributes ? 1 : 0,
          where: 'react',
          variations: isset(products, asin, 'variations') ? JSON.stringify( products[asin].variations ) : 0,
          page_content : products[asin].DOM,
        };

        console.log( ourdata.variations );

        if( self.DEBUG ) console.log( 'our import params', ourdata );

        // remove the first product from state products
        delete products[asin];
        self.setState({ products });

        // DEBUG IN FIDDLER
        const theAjaxUrl = `${ajaxurl}?action=WooZoneNoAWSImport&sub_action=add_product${urlGetDebugStep().asparam}`;
        $.ajax({
          method: "POST",
          url: theAjaxUrl,
          data: ourdata,
          dataType: "json",
        })
        .done(function( response ) {

          if( self.DEBUG ) console.log( 'add product response: ', response );

          if( response.status == 'invalid' ){

            self.add_to_log( asin, `INVALID response`, 'error' )
            self.add_to_log( asin, response.msg, 'error' )

            if( response.msg_arr.length ){
              response.msg_arr.forEach( elm => {
                self.add_to_log( asin, elm, 'error' )
              })
            }

            self.setState({
              imported_products: { ...self.state.imported_products, [asin]: {
                status: 'invalid'
              } }
            })
          }

          if( response.status == 'valid' ){

            self.add_to_log( asin, `VALID response`, 'success' )
            self.add_to_log( asin, response.msg, 'success' )

            if( response.msg_arr.length ){
              response.msg_arr.forEach( elm => {
                self.add_to_log( asin, elm, 'notice' )
              })
            }

            self.setState({
              imported_products: { ...self.state.imported_products, [asin]: {
                status: 'valid'
              } }
            })
          }

          // setup the total time
          self.add_to_log( asin, 'Total execution time: ', 'end' )

          WooZoneNoAwsKeysImport.imported_products.asins_imported += `amz-${asin}`
          delete selected_products[asin];

          // update the state
          self.setState({ selected_products });

          // unblock the worker
          self.unblockWorker( asin );
        });
      }
    }
  }

  getProductMininalData( asin, DOM, url )
  {
    const { import_setup } = this.state;

    const size = humanFileSize(DOM.length);
    this.add_to_log( asin, `page size after content trimmed: <strong>${ size }</strong>`, 'notice' )

    if( DOM.length > 100 ){
      this.add_to_log( asin, `DOM response looks good`, 'success' )
    }else{
      this.add_to_log( asin, `response looks INVALID`, 'error' )
    }

    let productType = 'simple';

    if( DOM.includes('dimensionToAsinMap') && import_setup.type != 'simple' ){
      productType = 'variable';
    }

    this.add_to_log( asin, `Product type is ${productType}`, 'notice' )

    if( productType == 'variable' ){

      const detected_asin = DOM.split('"currentAsin" : "').pop().split('",')[0];
      const parent_asin = DOM.split('"parentAsin" : "').pop().split('",')[0];
      if( detected_asin == asin || parent_asin == asin ){
        this.add_to_log( asin, `Valid ASIN code: ${detected_asin} ${parent_asin == asin ? ' as parent.' : '' }`, 'success' )
      }else{
        this.add_to_log( asin, `INVALID ASIN code detected: ${detected_asin}`, 'error' )
      }

      const variations = JSON.parse( $.trim( DOM.split('"dimensionToAsinMap" :').pop().split('},')[0] + "}" ) );
      let uniqVariations = [];
      Object.keys(variations).map((object, index) => {
        //if( 0 && variations[object] != asin ){
          uniqVariations.push( variations[object] )
        //}
      })

      if( import_setup.variations < uniqVariations.length ){
        this.add_to_log( asin, `Number of variations setup is: ${import_setup.variations} and the product has ${uniqVariations.length} so ${ uniqVariations.length - import_setup.variations } will be ignored.`, 'notice' )
      }

      uniqVariations = uniqVariations.slice(0, import_setup.variations);

      if( uniqVariations.length == 0 ){
        this.add_to_log( asin, `No variations for: ${asin}`, 'notice' )

        // import this product as a wocoomerce simple product
        productType = 'simple';

      }else{
        this.add_to_log( asin, `=> Request for the following variations: ${uniqVariations.join(', ')}`, 'notice' )

        const request_url = `https://www.${ getDomain(url) }/gp/p13n-shared/faceout-partial?reftagPrefix=homepage&widgetTemplateClass=PI::Similarities::ViewTemplates::Carousel::Desktop&faceoutTemplateClass=PI::P13N::ViewTemplates::Product::Desktop::CarouselFaceout&productDetailsTemplateClass=PI::P13N::ViewTemplates::ProductDetails::Desktop::Base&offset=0&asins=${uniqVariations.join(',')}`;

        if( self.DEBUG ) console.log( 'widget get variations', request_url );
        window.postMessage( {
          type: `${alias}transporter`,
          action: 'url-get-content',
          params: {
            'sub_action': 'variations',
            'url': request_url,
            'call_id': asin,
            'delay': Math.floor(Math.random() * 50) + 1,
            'home_url': WooZoneNoAwsKeysImport.validation.home_url
          }
        } );
      }
    }

    this.setState({ products: { ...this.state.products, [asin]: {
      DOM,
      size,
      domain: getDomain(url),
      type: productType,
      title: DOM.match(/<title[^>]*>([^<]+)<\/title>/)[1],
      status: ( productType == 'simple' ? 'done' : 'waiting_for_variations' )
    }} })

    if( productType == 'simple' ){
      this.sendToWZoneImport();
    }
  }

  buildCateg()
  {
    const { categ } = this.state;
    const categs = AzonCategs( this.state.country );

    if( categs.length == 0 ){
      return <div class="notice notice-error">{ this.state.country } not implemented yet!</div>
    }

    return <select id={ `${alias}filed-categ` } value={ categ } onChange={ (e) => {
      e.preventDefault();

      this.setState({ categ: e.target.value, isfrom: '' })
    }}>
      {
        Object.keys(categs).map( (key, index) => {
          return <option key={ index } value={ key }>{ categs[key] }</option>
        })
      }
    </select>
  }

  addProductBtn( asin, event )
  {
    this.setState({
      selected_products: { ...this.state.selected_products, [asin]: this.search_results_products[asin] }
    })
  }

  buildSearchResults()
  {
    const { search_result_page, country, selected_products } = this.state;
    const self = this;

    if( search_result_page ){

      if( Object.keys(this.search_results_products).length == 0 ){
        const page_doc = $(search_result_page);

        let cc = 0;
        page_doc.find("div.s-result-list div.s-result-item").each( function(){
          const item = $(this);

          // skip if is sponsored
          if( item.html().indexOf('sp-sponsored-result') == '-1' ){
            cc++;
            const asin = item.data('asin'),
              image = item.find(".s-image").attr('src'),
              name = $.trim( item.find('h5').text() ),
              price = item.find(".a-price").html(),
              rating = item.find(".a-icon-star-small").text(),
              brand = item.find('h5').next('div').text();

            let variation_asin = '';

            const asin_regex = /\/dp\/(.*)\//gm;
            const match = asin_regex.exec( item.html() );

            if( match && match.length > 0 ){
              if( isset(match, 1) ){
                variation_asin = match[1];
              }
            }

            if( asin /*&& cc < 10*/ ){
              self.search_results_products[asin] = {
                country,
                variation_asin,
                name,
                price,
                image: image.replace( /\._(.*)_\./, '._SS200_.' ),
                brand,
                rating,
                url: `https://www.amazon.${country}/dp/${asin}`,
                variation_url: `https://www.amazon.${country}/dp/${variation_asin}`,
              }
            }
          }
        })
      }

      if( Object.keys(this.search_results_products).length ){
        // reset the nb of products for each new search
        this.nbProducts = 0;
        
        return <div className={ `${alias}search-results` }>
          <h2>Search Results:</h2>
          { this.buildPagination() }
          <ul>{

            Object.keys(this.search_results_products).map( function(key, index){

              self.nbProducts++;
              let already_imported = false;
              if( WooZoneNoAwsKeysImport.imported_products.status == 'valid' && WooZoneNoAwsKeysImport.imported_products.asins_imported.includes( `amz-${key}` ) ){
                already_imported = true;
              }

              self.search_results_products[key]['already_imported'] = already_imported;

              return <li>
                <a href={ self.search_results_products[key].url } target="_blank">
                  <img src={ self.search_results_products[key].image } />
                </a>
                <div>
                  <h5><a href={ self.search_results_products[key].url } target="_blank">{ self.search_results_products[key].name }</a></h5>
                  <h4>{ self.search_results_products[key].brand }</h4>
                  <div className={ `${alias}price` }>{ self.search_results_products[key].price ? <div dangerouslySetInnerHTML={{__html: self.search_results_products[key].price}}></div> : '' }</div>
                  <h4>{ self.search_results_products[key].rating }</h4>

                  {
                    already_imported == true ? <span className={ `${alias}already-imported` }>Already Imported</span> : Object.keys(selected_products).includes( key ) ? <span className={ `${alias}data-added` }>product added to import list</span> : <button data-asin={ key } className={ `${alias}get-product` } onClick={ self.addProductBtn.bind( self, key ) }>Add to import list</button>
                  }
                </div>
              </li>
            })
          }</ul>

          { this.buildPagination() }
        </div>
      }
    }
  }

  buildPagination()
  {
    return <div className={ `${alias}pagination-wrapper` }><ReactPaginate
      previousLabel={ <span class="dashicons dashicons-arrow-left-alt2"></span> }
      nextLabel={ <span class="dashicons dashicons-arrow-right-alt2"></span> }
      breakLabel={'...'}
      breakClassName={'break-me'}
      pageCount={ Math.ceil( this.state.pagination.totals / this.state.pagination.per_page ) }
      marginPagesDisplayed={ 2 }
      pageRangeDisplayed={ 3 }
      onPageChange={ (data) => {
        this.setState({ paged: data.selected + 1, isfrom: 'pagination' })
        this.searchFieldPaged.current.value = data.selected;

        setTimeout( () => {
          this.searchFormRef.current.querySelector('button[type="submit"]').click()
        }, 50 )
      } }
      containerClassName={ `${alias}pagination` }
      subContainerClassName={'pages pagination'}
      activeClassName={ '_is_selected' }
      forcePage={ this.state.paged - 1 }
    /></div>
  }

  buildLoader()
  {
    return <div className={ `${alias}loader` }><div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
  }

  add_to_log( asin='', msg='', type='none' )
  {
    const { logs } = this.state;

    // calculte the total number
    if( type == 'end' ){
      msg = `${msg} <strong>${ ((new Date() - this.state.logs[asin][0].when) / 1000).toFixed(2) } seconds</strong>`;
    }

    let asin_log = isset( logs, asin ) ? logs[asin].slice(0) : [];
    asin_log.push({ msg, type, when: new Date() });

    //this.setState({ logs: { ...this.state.logs, [asin]: asin_log }});
    this.state.logs = { ...this.state.logs, [asin]: asin_log };
  }

  unblockWorker( asin='' )
  {
    const { workers } = this.state;

    Object.keys(workers).forEach( (key) => {

      // let's free this worker
      if( workers[key]['asin'] == asin ) {
        workers[key].status = 'free';
      }
    })
  }

  importWorker()
  {
    window.setInterval( () => {

      const { import_in_progress, workers, products_get_in_progress, import_setup } = this.state;
      const self = this;

      if( import_in_progress ){
        const { selected_products, import_setup } = this.state;

        // check if we have any free workers
        let new_job_key = -1;

        Object.keys(workers).forEach( (key) => {

          let worker = workers[key];

          if( worker.status == 'free' ){

            // first ASIN is not already done or in progress
            let new_asin = false;
            Object.keys(selected_products).forEach( (key) => {

              // if product is not already in queue in other worker
              if( !products_get_in_progress.includes(key) ){
                new_asin = key;
              }
            })

            if( new_asin === false ){

              // stop the import in progress process
              self.setState({ import_in_progress: false });

              if( self.DEBUG ) console.log("no more new products!");
            }

            if( new_asin ){
              // change current free worker status
              workers[key].status = 'busy';
              workers[key].when = new Date();
              workers[key].asin = new_asin;

              // add to products_get_in_progress queue
              products_get_in_progress.push( new_asin );

              // it's time to get the product and import
              let page_url = selected_products[new_asin].url;

              if( import_setup.type == 'variations' && selected_products[new_asin].variation_asin.length > 0 ){
                page_url = selected_products[new_asin].variation_url;
              }

              self.add_to_log(new_asin, `===> ${new_asin} - Start Import`, 'start')
              self.add_to_log(new_asin, `request url: <a href="${page_url}" target="_blank">${page_url}</a>`, 'notice')

              // make the request to extention for cross domain passing
              window.postMessage( {
                type: `${alias}transporter`,
                action: 'url-get-content',
                params: {
                  'sub_action': 'product_page',
                  'url': page_url,
                  'call_id': new_asin,
                  'delay': Math.floor(Math.random() * 50) + 1,
                  'home_url': WooZoneNoAwsKeysImport.validation.home_url
                }
              } );

              self.setState({ products_get_in_progress })

              // fake get product here ...
              if( 0 ){

                let in_time = Math.floor(Math.random() * (1000 - 500 + 1)) + 500
                setTimeout( () => {

                  self.add_to_log(new_asin, `===> ${new_asin} - Start Import`, 'start')

                  self.setState({
                    imported_products: { ...self.state.imported_products, [new_asin]: {
                      status: 'valid'
                    } }
                  })

                  WooZoneNoAwsKeysImport.imported_products.asins_imported += `amz-${new_asin}`
                  delete selected_products[new_asin];

                  // update the state
                  self.setState({ selected_products });

                  // unblock the worker
                  self.unblockWorker( new_asin );

                }, in_time)
              }
            }
          }
        })
      }
    }, 200)
  }

  buildImportList()
  {
    const { selected_products, import_setup, products_get_in_progress, import_in_progress } = this.state;
    const self = this;

    return Object.keys(selected_products).length ? <div className={ `${alias}import-block-wrapper` }>
      <h3>Import list</h3>
      <ul>
        {
          Object.keys(selected_products).map( function(key, index){
            return <li key={ key }>
              <span class="dashicons dashicons-no-alt" title="Remove video from import list" onClick={ () => {
                if( confirm("Are you sure you want to delete...?") ){
                  delete selected_products[key];
                  self.setState( selected_products )
                }
              }}></span>
              <a href={ selected_products[key].url } target="_blank">
                <img src={ selected_products[key].image } />
              </a>
              <h5>{ key }</h5>

              { products_get_in_progress.includes(key) ? self.buildLoader() : '' }
            </li>
          })
        }
      </ul>

      <form className={ `${alias}import-form` } id={ `${alias}import-form` }>
        <div className={ `${alias}setting` }>

          <h3>Import product Type</h3>
          <select className={ `${alias}import-product-type` } value={ import_setup.type } onChange={ (event) => this.setState({ import_setup: { ...import_setup, ['type']: event.target.value }}) }>
            <option value="simple">Simple Product</option>
            <option value="variations">Variable Product</option>
          </select>

          {
            import_setup.type == 'simple' ?
              <p>This option will import only the current product, with no variations.</p>
                :
              <p>This option will import this product parent and its variations according to the settings setup below.</p>
          }

          {
            import_setup.type == 'variations' ?
              <Fragment>
                <h3>Number of Variations</h3>
                <RangeControl
                  value={ import_setup.variations }
                  onChange={ (val) => this.setState({ import_setup: { ...import_setup, ['variations']: val }}) }
                  min={ 0 }
                  step={ 1 }
                  max={ 99 }
                  name={ `${alias}field-variations` }
                />
              </Fragment>
              : ''
          }

        </div>

        <div className={ `${alias}setting` }>
          <h3>Number of Images</h3>

          <RangeControl
            value={ import_setup.images }
            onChange={ (val) => this.setState({ import_setup: { ...import_setup, ['images']: val }}) }
            min={ 0 }
            step={ 1 }
            max={ 100 }
            name={ `${alias}field-images` }
          />
        </div>

        <div className={ `${alias}setting` }>
          <h3>Others</h3>

          <CheckboxControl
            label="Import attributes"
            checked={ import_setup.attributes }
            onChange={ (val) => this.setState({ import_setup: { ...import_setup, ['attributes']: !import_setup.attributes }}) }
            name={ `${alias}field-attributes` }
          />

          <CheckboxControl
            label="Spin on Import"
            checked={ import_setup.spin }
            onChange={ (val) => this.setState({ import_setup: { ...import_setup, ['spin']: !import_setup.spin }}) }
            name={ `${alias}field-spin` }
          />

          <RangeControl
            value={ import_setup.threads }
            onChange={ (val) => this.setState({ import_setup: { ...import_setup, ['threads']: val }}) }
            min={ 1 }
            label="Nb. of threads simultaneously (how many products to import in the same time)"
            step={ 1 }
            max={ 5 }
            className={ `${alias}field-threads` }
            name={ `${alias}field-threads` }
          />

        </div>

        <div className={ `${alias}setting` }>
          <h3>Import in</h3>
          <div dangerouslySetInnerHTML={{__html: WooZoneNoAwsKeysImport.import_in_category}}></div>
        </div>

        {
          import_in_progress ?
            <button className={ `${alias}stop-btn` } onClick={ (e) => { e.preventDefault(); this.setState({ import_in_progress: false })} }>Stop Import</button>
            :
            <button className={ `${alias}import-btn` } onClick={ this.startImport.bind(this) }>Import selected products</button>
        }

      </form>
    </div>
     : ''
  }

  startImport( event )
  {
    event.preventDefault();

    // create workers based on import setup number of threads
    let workers = {};
    let nb_of_workers = this.state.import_setup.threads;


    // we don't need more workers than selected products
    if( Object.keys(this.state.selected_products).length < nb_of_workers ){
      nb_of_workers = Object.keys(this.state.selected_products).length;
    }

    // create workers here
    for (let cc = 0; cc < nb_of_workers; cc++) {
      workers[cc] = {
        status: 'free',
        when: new Date(),
        asin: ''
      }
    }

    this.setState({
      workers: workers,
      import_in_progress: true
    });
  }

  buildLogList()
  {
    const { logs, imported_products, view_log_asin } = this.state;

    if( Object.keys(logs).length > 0 ){

      if( view_log_asin === false) {
        this.setState({ view_log_asin: Object.keys(logs)[0] })
      }

      return <div className={ `${alias}import-log-wrapper ${this.state.show_log ? '' : 'is_hide'}` } >
        <a href="#" title="Click to Close this Panel" onClick={ (e) => { e.preventDefault(); this.setState({ show_log: !this.state.show_log })}} className={ `${alias}show-log-btn` }><span class="dashicons dashicons-info"></span><span>import log</span></a>
        <div className={ `${alias}import-log-scrollbar` }>
          <div className={ `${alias}import-log-anchors-wrapper` }>
            <ul className={ `${alias}import-log-anchors` }>
              {
                Object.keys(logs).map( ( asin, index ) => {

                  // calculte the total number
                  let total_time = 0;
                  let last_key = Object.keys(logs[asin])[Object.keys(logs[asin]).length-1];
                  if( logs[asin][last_key].type == 'end' ){
                    total_time = (( logs[asin][last_key].when - logs[asin][0].when) / 1000).toFixed(2);
                  }

                  return <li key={ index } className={ view_log_asin == asin ? `${alias}asin-selected` : '' } onClick={ () => { this.setState({ view_log_asin: asin }) }}>
                    {
                      total_time > 0 ?
                        <div className={ `${alias}asin-total-times` }>{total_time} sec.</div>
                        : <div>...</div>
                    }
                    <div>
                      <span>{asin}</span>
                      {
                        !Object.keys(imported_products).includes(asin) ?
                          <span className={ `${alias}asin-in-progress` }>in progress</span>
                            :
                          <span className={ `${alias}asin-${imported_products[asin].status}` }>{imported_products[asin].status}</span>
                      }
                    </div>
                  </li>
                } )
              }
            </ul>
          </div>

          <ul className={ `${alias}import-log` }>
            {
              Object.keys(logs).map( ( asin, index ) => {
                if( view_log_asin == asin ){
                  return <li key={ index }>
                    {
                      logs[asin].map( (log, index) => {
                        return <p key={ index } className={ `${alias}import-status-${log.type}` }>
                            <span className={ `${alias}import-time` }>[{
                              `${log.when.getHours()}:${log.when.getMinutes()}:${log.when.getSeconds()}:${log.when.getMilliseconds()}`
                            }]</span>

                            <span className={ `${alias}import-msg` }>{ <span dangerouslySetInnerHTML={{__html: log.msg}}></span> }</span>
                        </p>
                      })
                    }
                  </li>
                }
              } )
            }
          </ul>
        </div>
      </div>
    }
  }

  launchSearch( event )
  {
    event.preventDefault();
    let { country, keyword, categ, paged, search_sort, isfrom } = this.state;
    console.log( 'isfrom', isfrom );

    // reset results
    this.search_results_products = {};
    if ( 'pagination' !== isfrom ) {
      paged = 1;
      this.setState({ paged: 1, pagination: {} });
    }

    let search_url = `https://www.amazon.${country}/s?k=${keyword}&i=${categ}&page=${paged}`;
    if ( '' !== search_sort ) {
      search_url = `${search_url}&s=${search_sort}`;
    }

    // debug
    //search_url = '../page2.html';

    window.postMessage( {
      type: `${alias}transporter`,
      action: 'url-get-content',
      params: {
        'sub_action': 'search',
        'url': search_url,
        'call_id': makeid(),
        'delay': 100,
        'home_url': WooZoneNoAwsKeysImport.validation.home_url
      }
    } );

    this.setState({ show_main_loader: true, search_result_page: null });
  }

  launchValidation( event )
  {
    event.preventDefault();

    const ipc = $.trim(event.target.elements.ipc.value);
    const email = event.target.elements.email.value;
    const home_url = event.target.elements.home_url.value;

    let is_valid_ipc = true;
    if( ipc == '' ){
      is_valid_ipc = false;
    }

    if( is_valid_ipc == false ){
      alert("invalid IPC code!");
    }

    let validate_url = `http://cc.aa-team.com/validation/validate.php?ipc=${ipc}&home_url=${home_url}&email=${email}&app=${WooZoneNoAwsKeysImport.validation.plugin_alias}-extension`;
    // debug
    //search_url = '../page2.html';

    window.postMessage( {
      type: `${alias}transporter`,
      action: 'url-get-content',
      params: {
        'sub_action': 'validation',
        'url': validate_url + `&no_cache=${ makeid() }`,
        'call_id': makeid(),
        'delay': 1,
        'home_url': WooZoneNoAwsKeysImport.validation.home_url
      }
    } );

    this.setState({ show_main_loader: true });
  }

  removeAllFromQueue( event )
  {
    event.preventDefault();

    if(confirm("Are you sure you want to remove all the products from import Queue?")){
      this.setState({ selected_products: {} });
    }
  }

  addAllToQueue( event )
  {
    event.preventDefault();

    const new_products = {}
    Object.keys(this.search_results_products).forEach( (key) => {
      const product = this.search_results_products[key];

      if( !product.already_imported ){
        new_products[key] = product
      }
    })

    this.setState({
      selected_products: { ...this.state.selected_products, ...new_products }
    })
  }

  buildQuickMenu()
  {
    const { quick_menu, selected_products } = this.state;

    return <div className={ `${alias}quick-menu ${quick_menu == 'open' ? '__is_opened' : '' }` }>
      <h2 onClick={ () => this.setState({ quick_menu: ( quick_menu == 'open' ? 'close': 'open' )})}>
        {
          quick_menu == 'open' ?
            <Fragment>
              <span class="dashicons dashicons-arrow-down-alt2"></span>
              Close Quick Menu
            </Fragment>
          :
            <Fragment>
              <span class="dashicons dashicons-arrow-up-alt2"></span>
              Open Quick Menu
            </Fragment>
        }

      </h2>

      <p>This menu is contextual, you can find more or less actions according to your search.</p>
      <ul>
        {
          this.search_results_products && Object.keys(this.search_results_products).length ? <li><a href="#" onClick={ this.addAllToQueue.bind(this) }>Add All NEW Products to Queue</a></li> : ''
        }

        {
          Object.keys(selected_products).length ? <li><a href="#" onClick={ this.removeAllFromQueue.bind(this) }>Empty Products Queue</a></li> : ''
        }

        <li><a href="#" onClick={ (event) => { event.preventDefault(); window.scrollTo(0, 0) } }><span class="dashicons dashicons-arrow-up-alt"></span> Scroll to TOP</a></li>
        <li><a href="#" onClick={ (event) => { event.preventDefault(); window.scrollTo(0, document.body.scrollHeight) } }><span class="dashicons dashicons-arrow-down-alt"></span> Scroll to BOTTOM</a></li>
      </ul>
    </div>
  }

  render()
  {
    const { country, keyword, search_result_page, paged, show_main_loader, import_setup, products, imported_products, is_chrome, extention_loaded, ipc_is_valid } = this.state;

    if( is_chrome === false ){
      return <div className={ `${alias}get-google-chrome` }>
        <img src={ `${WooZoneNoAwsKeysImport.assets_url}images/chrome-logo.svg` } />
        <h1>This module works only in Google Chrome Browser and using <a href="https://chrome.google.com/webstore/detail/wzone-no-pa-api/pgaabedmnacicfkgnbfdodgmdmpbcnpk" target="_blank">WZone NO PA API Google Chrome extension</a>.</h1>
        <a className="_is_btn" href="https://www.google.com/chrome/" target="_blank">Download Chrome</a>
      </div>
    }

    if( extention_loaded === false ){
      return <div className={ `${alias}get-extension` }>
        <div className={ `${alias}validate-left` }>
          <p>Please check if the WZone NO PA API Chrome extension is installed!</p>
          <p className={ `${alias}info-block` }>In order to use this module please make sure you have the latest WZone NO PA API Chrome extension installed - V1.0.0 </p>
          <p className={ `${alias}info-text` }>After you install/update it please refresh this page.</p>
          <div className={ `${alias}get-extension-block` }>
            <img src={ `${WooZoneNoAwsKeysImport.assets_url}images/direct-import-logo.png` } />
            <div>
              <h4>WZone NO PA API Google Chrome extension</h4>
              <a className="_is_btn" href="https://chrome.google.com/webstore/detail/wzone-no-pa-api/pgaabedmnacicfkgnbfdodgmdmpbcnpk" target="_blank">Add to Chrome</a>
            </div>
          </div>
          </div>

          <div className={ `${alias}validate-right` }>
            <img src={ `${WooZoneNoAwsKeysImport.assets_url}images/API-NO.jpg` } />
          </div>
      </div>
    }

    if( ipc_is_valid === false ){
      return <Fragment>
        { show_main_loader ? this.buildLoader() : '' }
        <div className={ `${alias}validate-extension` }>
        <div className={ `${alias}validate-left` }>
          <h2>WZone NO PA API Google Chrome Extension Validation.</h2>
          <div className={ `${alias}validate-extension-info` }>
            <p>This code is used for validation so you can use the NO AWS KEYS Import Feature.</p>
            <p>You need to log into your CodeCanyon account and go to your “Downloads” page. Locate the plugin you purchased in your “Downloads” list and click on the “License Certificate” link next to the download link. After you have downloaded the certificate you can open it in a text editor such as Notepad and copy the Item Purchase Code.</p>
            <p><a target="_blank" href="http://docs.aa-team.com/woocommerce-amazon-affiliates/documentation/activate-plugin/">Read more here. </a></p>
          </div>
          <form onSubmit={ this.launchValidation.bind(this) }>
            <input type="hidden" name="home_url" value={ WooZoneNoAwsKeysImport.validation.home_url } />
            <input type="text" name="ipc" defaultValue={ WooZoneNoAwsKeysImport.validation.ipc ? WooZoneNoAwsKeysImport.validation.ipc : '' } placeholder="Enter your Envato Purchase Code here" />
            <input type="text" name="email" defaultValue={ WooZoneNoAwsKeysImport.validation.email ? WooZoneNoAwsKeysImport.validation.email : '' } placeholder="Enter site owner email here" />
            <button className="_is_btn" ><span class="dashicons dashicons-admin-network"></span> Unlock NO AWS KEYS Import</button>
          </form>
          </div>
          <div className={ `${alias}validate-right` }>
            <img src={ `${WooZoneNoAwsKeysImport.assets_url}images/API-NO.jpg` } />
          </div>
        </div>
      </Fragment>
    }

    return <Fragment>
      <form onSubmit={ this.launchSearch.bind(this) } className={ `${alias}search-form` } ref={ this.searchFormRef } data-country={ country } id="WooZone-NAWS-search-form">

        <AZON_Country_Dropdown onChange={ (value) => {
          this.setState({
            country: value,
            categ: 'aps',
            isfrom: '',
          })
        } } defaultValue={ country } list={ Country_List() } />

        <div className={ `${alias}custom-select` }>{ this.buildCateg() }</div>
        <input id={ `${alias}filed-keyword` } placeholder="Search keyword here" type="text" defaultValue={ keyword } onChange={ (e) => {
          this.setState({ keyword: e.target.value, isfrom: '' });
        } } />
        <input id={ `${alias}filed-paged` } ref={ this.searchFieldPaged } type="hidden" defaultValue={ paged } />

        <div className={ `${alias}custom-select` }>
          <select id={ `${alias}filed-filter` } defaultValue={ this.state.search_sort } onChange={ (e) => { this.setState({ search_sort: e.target.value, isfrom: '' }) }}>
            <option value="">NONE</option>
            <option value="relevanceblender">Featured</option>
            <option value="price-asc-rank">Price: Low to High</option>
            <option value="price-desc-rank">Price: High to Low</option>
            <option value="review-rank">Avg. Customer Review</option>
            <option value="date-desc-rank">Newest Arrivals</option>
          </select>
        </div>
        <button class="wz-search-btn" type="submit">Search for Products</button>
      </form>

      { this.buildSearchResults() }

      { show_main_loader ? this.buildLoader() : '' }

      { this.buildImportList() }

      { this.buildLogList() }

      { this.buildQuickMenu() }

    </Fragment>
  }
}

wp.domReady( function() {
  if( image_block_wrapper ) render( <WooZoneNoAWSImport />, image_block_wrapper );
} );
